import axios from 'axios'

const loadSTL = (stlUrl) => {
  return new Promise((resolve, reject) => {
    const headers = {
      'Content-Type': 'application/json',
    }

    axios({
      url: `https://lumialase.lumialase.com/api/LumiaLase/ConvertStlFile`,
      method: 'POST',
      headers: headers,
      data: JSON.stringify({
        storage_type: 'http',
        //stl_url: "https://storage.cloud.google.com/3dplugin/dc4f8324-3548-11ee-be56-0242ac120002/stl_files/(51411)__Actives-Dual-Lid-Bundle---Spout-Bottle-With-Straw-Lid.stl",
        stl_url: stlUrl,
        smoothness: 0.5,
        Data: '',
      }),
    })
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export default loadSTL
